import { render, staticRenderFns } from "./AccountSubscription.vue?vue&type=template&id=98d9c4a8&scoped=true&"
import script from "./AccountSubscription.vue?vue&type=script&lang=js&"
export * from "./AccountSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d9c4a8",
  null
  
)

export default component.exports